<template >
  <div>
    <div class="container-flight margin_container_hf">
     
    </div>
  </div>
</template>


<script>
import Store from "./store/index";
require("linqjs");

export default {
  store: Store,

  components: {  },
  data() {
    return {
      responseId: Number,
      responseLabel: "خطا در رزرو",
      params: {},
      tickets: [],
      roomDetails: [],
      passengers: [],
      flightTickets: [],
      ticketActionModel: {},
    };
  },
  created() {
    this.params = this.$route.query;
    this.responseId = Number(this.params.id);

    if (this.responseId < 1) {
      if (this.responseId === -3) {
        this.responseLabel = "خطا در پرداخت";
      } else {
        this.responseLabel = "خطا در رزرو";
      }
    }

    if (this.responseId === 17) {
      this.responseLabel = "انصراف از پرداخت";
    }
    // const decodeId = atob(this.params.id);
    this.getTicket(this.params.id);
  },
  computed: {},
  methods: {
  
  
    async getTicket(reserveNumber) {
    this.$router.push({ path: '/vouchers/hotelFlight/', query: { id: reserveNumber }})
    //  this.$router.push({ path: 'vouchers/hotelFlight', query: { id: reserveNumber } })
  
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss">

</style>